var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box-main" }, [
    _c("div", { staticClass: "main" }, [
      _c("div", [
        _c("div", { staticClass: "main-title" }, [
          _c("img", {
            staticClass: "arrow-left",
            attrs: { src: require("@/assets/img/arrow-left.svg"), alt: "" },
            on: { click: _vm.pushBack },
          }),
          _c("span", { staticClass: "ml20" }, [_vm._v(_vm._s(_vm.name))]),
        ]),
      ]),
      _c(
        "div",
        [
          _c("topicList", {
            ref: "topicList",
            attrs: { sourceId: _vm.sourceId },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }